export enum DamageLabelShape {
  Rectangle,
  Polygon
}
